// Miroir frontend de boldeeback/config/vatConfig.js — TVA sur les frais de service
// uniquement (jamais sur le prix de la ressource, jamais sur un Don). Utilisé ici pour que
// le prix TTC affiché avant paiement corresponde exactement au montant réellement encaissé
// par le serveur (cf. routes/User/Payment.routes.js côté backend).
//
// Affichage uniquement : le serveur reste la seule source de vérité pour le calcul réel au
// moment du paiement (cf. consigne "le frontend ne doit pas être la source de vérité
// financière").
const SERVICE_FEE_VAT_RATE = 0.20;

function calculateServiceFeeVAT(amountHt) {
  const vat = Math.round(amountHt * SERVICE_FEE_VAT_RATE * 100) / 100;
  const amountTtc = Math.round((amountHt + vat) * 100) / 100;
  return { amountHt, vatRate: SERVICE_FEE_VAT_RATE, vat, amountTtc };
}

export { SERVICE_FEE_VAT_RATE, calculateServiceFeeVAT };
